import React, { useCallback, useEffect, useState } from 'react';
import { config } from '../../config';
import { tvUploadRequest } from '../../services/tvUploadRequest';

export default function YouTubeProgrammeManager() {
    const [videos, setVideos] = useState([]);
    const [titre, setTitre] = useState('');
    const [url, setUrl] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const endpoint = `${config.apiBase}/youtube_programme.php`;
    const load = useCallback(async () => {
        try { setVideos((await tvUploadRequest(endpoint)).videos); }
        catch (error) { setMessage(error.message); }
    }, [endpoint]);
    useEffect(() => { load(); }, [load]);
    const publish = async event => {
        event.preventDefault(); setBusy(true); setMessage('');
        try {
            await tvUploadRequest(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ titre, url }) });
            setTitre(''); setUrl(''); await load(); setMessage('Vidéo ajoutée au programme étudiant.');
        } catch (error) { setMessage(error.message); }
        finally { setBusy(false); }
    };
    const remove = async id => {
        if (!window.confirm('Retirer cette vidéo du programme YouTube ?')) return;
        setBusy(true);
        try { await tvUploadRequest(endpoint, { method: 'DELETE', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id }) }); await load(); }
        catch (error) { setMessage(error.message); }
        finally { setBusy(false); }
    };
    return <section className="youtube-manager" aria-labelledby="youtube-programme-title">
        <div><span className="youtube-eyebrow">Une autre façon de diffuser</span><h2 id="youtube-programme-title">Programme YouTube</h2><p>Publiez un lien pour la chaîne YouTube des étudiants. Vos vidéos téléversées restent dans TV Sahel.</p></div>
        <form onSubmit={publish}><fieldset disabled={busy}><label>Titre de la vidéo<input required maxLength={200} value={titre} onChange={e => setTitre(e.target.value)} /></label><label>Lien YouTube<input required type="url" placeholder="https://www.youtube.com/watch?v=…" value={url} onChange={e => setUrl(e.target.value)} /></label><button type="submit">{busy ? 'Enregistrement…' : 'Ajouter au programme'}</button></fieldset></form>
        {message && <p role="status">{message}</p>}
        <p>Les vidéos doivent autoriser la lecture intégrée sur d’autres sites.</p>
        <ul>{videos.map(video => <li key={video.id}><img src={`https://i.ytimg.com/vi/${video.video_id}/mqdefault.jpg`} alt="" loading="lazy" /><div><strong>{video.titre}</strong><a href={`https://www.youtube.com/watch?v=${video.video_id}`} target="_blank" rel="noreferrer">Vérifier sur YouTube</a></div><button type="button" disabled={busy} onClick={() => remove(video.id)}>Retirer</button></li>)}</ul>
    </section>;
}
